export const getPriceNumber = (number) => {
    return Math.round(number * 100) / 100
};

export const getQtyNumber = (number) => {
    return Math.round(number * 1000) / 1000
};